const offersColumns = {
  docNumber: {
    key: 'docNumber',
    label: 'docNumber',
    type: 'function',
    sortable: 'custom',
    get: (value, row) => {
      const revisionNumber = row.revisionNumber
        ? String(`0${row.revisionNumber}`).slice(-2)
        : false;
      return revisionNumber ? `${value}-${revisionNumber}` : value;
    },
    minWidth: 150,
  },
  issuedAt: {
    key: 'issuedAtLocal',
    label: 'issuedAt',
    type: 'date',
    sortable: 'custom',
    minWidth: 110,
  },
  analysisCode: {
    key: 'analysis.code',
    label: 'analysisCode',
    type: 'text',
    minWidth: 150,
  },
  customerName: {
    key: 'customerName',
    label: 'customerName',
    type: 'text',
    sortable: 'custom',
    minWidth: 150,
  },
  expirationDate: {
    key: 'expirationDate',
    label: 'expirationDate',
    type: 'date',
    sortable: 'custom',
    minWidth: 110,
  },
  // price: {
  //   key: 'price',
  //   label: 'price',
  //   type: 'text',
  //   sortable: 'custom',
  // },
  type: {
    key: 'type',
    label: 'type',
    type: 'enum',
    enum: 'offerType',
    sortable: 'custom',
    minWidth: 80,
  },
  samplesCount: {
    key: 'samplesCount',
    label: 'usedAnalysis',
    type: 'text',
    minWidth: 80,
  },
  quantity: {
    key: 'quantity',
    label: 'offerRemaining',
    type: 'text',
    minWidth: 80,
  },
  // enabled: {
  //   label: 'offerEnabled',
  //   type: 'boolean',
  //   minWidth: 40,
  //   sortable: false,
  //   align: 'center',
  // },
  // actions: {
  //   key: 'actions',
  //   label: 'actions',
  //   type: 'actions',
  //   sortable: false,
  //   buttons: [
  //     {
  //       name: 'showDetail',
  //       icon: 'fas fa-eye',
  //     },
  //   ],
  // },
};

export default offersColumns;
